import '@angular/compiler';
import { PageXrayExperiments_runtime_v4Component } from './page.xray.experiments_runtime_v4/page.xray.experiments_runtime_v4.component';
import { PageXrayExperimentsComponent } from './page.xray.experiments/page.xray.experiments.component';
import { PageXrayDataset_viewer_runtime_v2Component } from './page.xray.dataset_viewer_runtime_v2/page.xray.dataset_viewer_runtime_v2.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageXrayNormality_review_runtime_v4Component } from './page.xray.normality_review_runtime_v4/page.xray.normality_review_runtime_v4.component';
import { PageXrayExperiment_guideComponent } from './page.xray.experiment_guide/page.xray.experiment_guide.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageXrayExperiments_runtime_v7Component } from './page.xray.experiments_runtime_v7/page.xray.experiments_runtime_v7.component';
import { PageXrayData_manager_entry_v1Component } from './page.xray.data_manager_entry_v1/page.xray.data_manager_entry_v1.component';
import { PageXrayNormality_review_runtime_v13Component } from './page.xray.normality_review_runtime_v13/page.xray.normality_review_runtime_v13.component';
import { PageXrayModels_runtime_v1Component } from './page.xray.models_runtime_v1/page.xray.models_runtime_v1.component';
import { PageXrayComponent } from './page.xray/page.xray.component';
import { PageXrayLabel_review_runtime_v7Component } from './page.xray.label_review_runtime_v7/page.xray.label_review_runtime_v7.component';
import { PageXrayExperiments_runtime_v10Component } from './page.xray.experiments_runtime_v10/page.xray.experiments_runtime_v10.component';
import { PageXrayDatasetComponent } from './page.xray.dataset/page.xray.dataset.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageXrayExperiments_runtime_v6Component } from './page.xray.experiments_runtime_v6/page.xray.experiments_runtime_v6.component';
import { PageXrayNormality_review_runtime_v6Component } from './page.xray.normality_review_runtime_v6/page.xray.normality_review_runtime_v6.component';
import { PageXrayExperiments_runtime_v9Component } from './page.xray.experiments_runtime_v9/page.xray.experiments_runtime_v9.component';
import { PageXrayLabel_review_runtime_v3Component } from './page.xray.label_review_runtime_v3/page.xray.label_review_runtime_v3.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageXrayLabel_reviewComponent } from './page.xray.label_review/page.xray.label_review.component';
import { PageXrayDataset_upload_runtime_v1Component } from './page.xray.dataset_upload_runtime_v1/page.xray.dataset_upload_runtime_v1.component';
import { PageXrayLabel_review_runtime_v6Component } from './page.xray.label_review_runtime_v6/page.xray.label_review_runtime_v6.component';
import { PageXrayLabel_review_runtime_v4Component } from './page.xray.label_review_runtime_v4/page.xray.label_review_runtime_v4.component';
import { PageXrayNormality_review_runtime_v5Component } from './page.xray.normality_review_runtime_v5/page.xray.normality_review_runtime_v5.component';
import { PageXrayDataset_viewer_runtime_v1Component } from './page.xray.dataset_viewer_runtime_v1/page.xray.dataset_viewer_runtime_v1.component';
import { PageXrayExperiments_runtime_v3Component } from './page.xray.experiments_runtime_v3/page.xray.experiments_runtime_v3.component';
import { PageXrayExperiments_runtime_v5Component } from './page.xray.experiments_runtime_v5/page.xray.experiments_runtime_v5.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageXrayNormality_review_runtime_v12Component } from './page.xray.normality_review_runtime_v12/page.xray.normality_review_runtime_v12.component';
import { PageXrayNormality_review_runtime_v7Component } from './page.xray.normality_review_runtime_v7/page.xray.normality_review_runtime_v7.component';
import { PageXrayExperiments_runtime_v8Component } from './page.xray.experiments_runtime_v8/page.xray.experiments_runtime_v8.component';
import { PageXrayNormality_review_runtime_v3Component } from './page.xray.normality_review_runtime_v3/page.xray.normality_review_runtime_v3.component';
import { PageXrayLabel_review_runtime_v5Component } from './page.xray.label_review_runtime_v5/page.xray.label_review_runtime_v5.component';
import { PageXrayModelsComponent } from './page.xray.models/page.xray.models.component';
import { PageXrayLabel_review_runtime_v2Component } from './page.xray.label_review_runtime_v2/page.xray.label_review_runtime_v2.component';
import { PageXrayNormality_review_runtime_v14Component } from './page.xray.normality_review_runtime_v14/page.xray.normality_review_runtime_v14.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageXrayLabel_review_runtime_v1Component } from './page.xray.label_review_runtime_v1/page.xray.label_review_runtime_v1.component';
import { PageXrayNormality_reviewComponent } from './page.xray.normality_review/page.xray.normality_review.component';

const INDEX_PAGE = "";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "__internal/xray-experiments-runtime-v4",
                component: PageXrayExperiments_runtime_v4Component,
                "app_id": "page.xray.experiments_runtime_v4"
            },
            {
                "path": "page.xray/training",
                component: PageXrayExperimentsComponent,
                "app_id": "page.xray.experiments"
            },
            {
                "path": "__internal/xray-dataset-viewer-runtime-v2",
                component: PageXrayDataset_viewer_runtime_v2Component,
                "app_id": "page.xray.dataset_viewer_runtime_v2"
            },
            {
                "path": "__internal/xray-normality-review-runtime-v4",
                component: PageXrayNormality_review_runtime_v4Component,
                "app_id": "page.xray.normality_review_runtime_v4"
            },
            {
                "path": "page.xray/experiment-guide",
                component: PageXrayExperiment_guideComponent,
                "app_id": "page.xray.experiment_guide"
            },
            {
                "path": "__internal/xray-experiments-runtime-v7",
                component: PageXrayExperiments_runtime_v7Component,
                "app_id": "page.xray.experiments_runtime_v7"
            },
            {
                "path": "page.xray/data-manager",
                component: PageXrayData_manager_entry_v1Component,
                "app_id": "page.xray.data_manager_entry_v1"
            },
            {
                "path": "__internal/xray-normality-review-runtime-v13",
                component: PageXrayNormality_review_runtime_v13Component,
                "app_id": "page.xray.normality_review_runtime_v13"
            },
            {
                "path": "__internal/xray-models-runtime-v1",
                component: PageXrayModels_runtime_v1Component,
                "app_id": "page.xray.models_runtime_v1"
            },
            {
                "path": "",
                component: PageXrayComponent,
                "app_id": "page.xray"
            },
            {
                "path": "__internal/xray-bucky-label-review-runtime-v7",
                component: PageXrayLabel_review_runtime_v7Component,
                "app_id": "page.xray.label_review_runtime_v7"
            },
            {
                "path": "__internal/xray-experiments-runtime-v10",
                component: PageXrayExperiments_runtime_v10Component,
                "app_id": "page.xray.experiments_runtime_v10"
            },
            {
                "path": "page.xray/training/dataset",
                component: PageXrayDatasetComponent,
                "app_id": "page.xray.dataset"
            },
            {
                "path": "__internal/xray-experiments-runtime-v6",
                component: PageXrayExperiments_runtime_v6Component,
                "app_id": "page.xray.experiments_runtime_v6"
            },
            {
                "path": "__internal/xray-normality-review-runtime-v6",
                component: PageXrayNormality_review_runtime_v6Component,
                "app_id": "page.xray.normality_review_runtime_v6"
            },
            {
                "path": "__internal/xray-experiments-runtime-v9",
                component: PageXrayExperiments_runtime_v9Component,
                "app_id": "page.xray.experiments_runtime_v9"
            },
            {
                "path": "__internal/xray-bucky-label-review-runtime-v3",
                component: PageXrayLabel_review_runtime_v3Component,
                "app_id": "page.xray.label_review_runtime_v3"
            },
            {
                "path": "page.xray/training/label-review",
                component: PageXrayLabel_reviewComponent,
                "app_id": "page.xray.label_review"
            },
            {
                "path": "__internal/xray-dataset-upload-runtime-v1",
                component: PageXrayDataset_upload_runtime_v1Component,
                "app_id": "page.xray.dataset_upload_runtime_v1"
            },
            {
                "path": "__internal/xray-bucky-label-review-runtime-v6",
                component: PageXrayLabel_review_runtime_v6Component,
                "app_id": "page.xray.label_review_runtime_v6"
            },
            {
                "path": "__internal/xray-bucky-label-review-runtime-v4",
                component: PageXrayLabel_review_runtime_v4Component,
                "app_id": "page.xray.label_review_runtime_v4"
            },
            {
                "path": "__internal/xray-normality-review-runtime-v5",
                component: PageXrayNormality_review_runtime_v5Component,
                "app_id": "page.xray.normality_review_runtime_v5"
            },
            {
                "path": "__internal/xray-dataset-viewer-runtime-v1",
                component: PageXrayDataset_viewer_runtime_v1Component,
                "app_id": "page.xray.dataset_viewer_runtime_v1"
            },
            {
                "path": "__internal/xray-experiments-runtime-v3",
                component: PageXrayExperiments_runtime_v3Component,
                "app_id": "page.xray.experiments_runtime_v3"
            },
            {
                "path": "__internal/xray-experiments-runtime-v5",
                component: PageXrayExperiments_runtime_v5Component,
                "app_id": "page.xray.experiments_runtime_v5"
            },
            {
                "path": "__internal/xray-normality-review-runtime-v12",
                component: PageXrayNormality_review_runtime_v12Component,
                "app_id": "page.xray.normality_review_runtime_v12"
            },
            {
                "path": "__internal/xray-normality-review-runtime-v7",
                component: PageXrayNormality_review_runtime_v7Component,
                "app_id": "page.xray.normality_review_runtime_v7"
            },
            {
                "path": "__internal/xray-experiments-runtime-v8",
                component: PageXrayExperiments_runtime_v8Component,
                "app_id": "page.xray.experiments_runtime_v8"
            },
            {
                "path": "__internal/xray-normality-review-runtime-v3",
                component: PageXrayNormality_review_runtime_v3Component,
                "app_id": "page.xray.normality_review_runtime_v3"
            },
            {
                "path": "__internal/xray-bucky-label-review-runtime-v5",
                component: PageXrayLabel_review_runtime_v5Component,
                "app_id": "page.xray.label_review_runtime_v5"
            },
            {
                "path": "page.xray/model-manager",
                component: PageXrayModelsComponent,
                "app_id": "page.xray.models"
            },
            {
                "path": "__internal/xray-bucky-label-review-runtime-v2",
                component: PageXrayLabel_review_runtime_v2Component,
                "app_id": "page.xray.label_review_runtime_v2"
            },
            {
                "path": "__internal/xray-normality-review-runtime-v14",
                component: PageXrayNormality_review_runtime_v14Component,
                "app_id": "page.xray.normality_review_runtime_v14"
            },
            {
                "path": "__internal/xray-bucky-label-review-runtime-v1",
                component: PageXrayLabel_review_runtime_v1Component,
                "app_id": "page.xray.label_review_runtime_v1"
            },
            {
                "path": "page.xray/training/normality-review",
                component: PageXrayNormality_reviewComponent,
                "app_id": "page.xray.normality_review"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_childs = layout.children;

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        if (child.path === '') {
            routes.push({
                path: '',
                component: child.component
            });
        } else {
            routes.push({
                matcher: (url: any) => {
                    let matcher = patternMatcher(child.path, url);
                    if (matcher) return matcher;
                    return null;
                },
                component: child.component
            });
        }
    }
}

routes.push({ path: '**', redirectTo: INDEX_PAGE });

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
